// extracted by mini-css-extract-plugin
module.exports = {"tooltipWpapper":"TooltipGlodal_tooltipWpapper__2sc0Z"};